module.exports = __webpack_public_path__ + "static/media/icon-whatsapp.0dfd6f16.svg";